import VueRouter from 'vue-router';
import Vue from 'vue';
import History from './pages/history/History';
import Collect from './pages/collect/Collect';
import Subscribe from './pages/subscribe/Subscribe';
import Setting from './pages/setting/Setting';
import Binge from './pages/binge/Binge';
Vue.use(VueRouter);
const isProd = process.env.NODE_ENV === 'production';
export const routeConfigs = [
    {
        name: 'history',
        path: '/history',
        component: History,
        meta: {
            tab: '._time',
            cname: '观看历史',
        },
    },
    {
        name: 'binge',
        path: '/binge',
        component: Binge,
        meta: {
            tab: '._binge',
            cname: '在追',
        },
    },
    {
        name: 'collect',
        path: '/playlist',
        component: Collect,
        meta: {
            tab: '._collect',
            cname: '收藏',
        },
    },
    {
        name: 'subscribe',
        path: '/subscribe',
        component: Subscribe,
        meta: {
            tab: '._follow',
            cname: '订阅',
        },
    },
    {
        name: 'setting',
        path: '/setting',
        component: Setting,
        meta: {
            tab: '._setting',
            cname: '设置',
        },
    },
];
export const router = new VueRouter({
    mode: 'history',
    base: isProd ? 'biu/u' : '',
    fallback: true,
    routes: routeConfigs.concat([{ path: '/', redirect: '/history' }]),
    scrollBehavior(_to, _from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return { x: 0, y: 0 };
    },
});
bindSideEvent();
function bindSideEvent() {
    const $nav = $('.user_navigate_list');
    routeConfigs.forEach((item) => {
        $nav.on('click', item.meta.tab, (e) => {
            e.preventDefault();
            if (!txv.login.isLogin()) {
                txv.login.openLogin();
            }
            router.push({ name: item.name });
        });
    });
    router.afterEach((to, _from) => {
        try {
            const config = routeConfigs.find(item => item.name === to.name);
            $nav.find('.current').removeClass('current');
            $nav.find(config.meta.tab).parent('.item')
                .addClass('current');
            document.title = `${to.meta.cname} - 腾讯视频`;
        }
        catch (error) {
            console.error(error);
        }
    });
}
